export const LOGIN = 'LOGIN'
export const SETREFRESHTOKEN = 'setRefreshToken'
export const SETTOKEN = 'setToken'
export const SETCITY = 'setUserCity'
export const SETLOGIN = 'setLogin'
export const SETWXLOGIN = 'setWXLogin'
export const SETMOBILE = 'setMobile'
export const SETUSERID = 'setUserID'
import userIcon from '../../../assets/icon/userIcon.jpg'
import cookieTools from '../../cookie'
export default {
  state: {
    token: '',
    refreshToken: '',
    headImgURL: '',
    address: '',
    authId: '',
    avatar: '',
    birthday: '',
    cityId: '',
    cityName: '',
    initPassword: '',
    mobilePhone: '',
    nickName: '',
    provinceId: '',
    provinceName: '',
    regionalismId: '',
    regionalismName: '',
    sex: '',
    userId: '',
    isSignSuccess: false,
    isWxLogin: false,
    infoComplete: false,
    //currentCity里面数据属性
    //            "name": "佛山市"
    //            "cityId": 440600,
    //            "cityName": "佛山市",
    //            "cityNamePingyin": "fo shan shi",
    //            "isCity": 1,
    //            "provinceId": 440000,
    //            "provinceName": "广东省",
    //            "regionalismId": 440600,
    //            "regionalismName": "佛山市",
    //            "regionalismNamePingyin": "fo shan shi"
    currentCity: undefined
  },
  actions: {
    setUserLogin ({ commit }, loginInfo) {
      commit(LOGIN, loginInfo)
    },
    setRefreshToken ({ commit }, value) {
      commit(SETREFRESHTOKEN, value)
    },
    setToken ({ commit }, value) {
      commit(SETTOKEN, value)
    },
    setUserCity ({ commit }, value) {
      commit(SETCITY, value)
    },
    setLogin ({ commit }, value) {
      commit(SETLOGIN, value)
    },//SETWXLOGIN
    setWXLogin ({ commit }, value) {
      commit(SETWXLOGIN, value)
    },
    setMobile ({ commit }, value) {
      commit(SETMOBILE, value)
    },
    setUserID ({ commit }, value) {
      commit(SETUSERID, value)
    }

  },
  mutations: {
    [LOGIN] (state, loginInfo) {
      state.headImgURL = loginInfo['headImgURL']
      state.isSignSuccess = true
      state.infoComplete = loginInfo['infoComplete']

      state.address = loginInfo['address']
      state.authId = loginInfo['authId']
      if (loginInfo['avatar'] !== undefined && loginInfo['avatar'].length != 0) {
        state.avatar = loginInfo['avatar']
      } else {
        state.avatar = userIcon
      }
      state.cityId = loginInfo['cityId']
      state.birthday = loginInfo['birthday']
      state.cityId = loginInfo['cityId']
      if (!loginInfo.hasOwnProperty('cityName')) {loginInfo.cityName = ''}
      state.cityName = loginInfo['cityName']
      state.initPassword = loginInfo['initPassword']
      state.mobilePhone = loginInfo['mobilePhone']
      state.nickName = loginInfo['nickName']
      state.provinceId = loginInfo['provinceId']
      if (!loginInfo.hasOwnProperty('provinceName')) {loginInfo.provinceName = ''}
      state.provinceName = loginInfo['provinceName']
      state.regionalismId = loginInfo['regionalismId']
      state.regionalismName = loginInfo['regionalismName']
      var sex = ''
      console.log(loginInfo['sex'])
      if (loginInfo['sex'] === 1) {
        sex = '男'
      } else if (loginInfo['sex'] === 2) {
        sex = '女'
      }
      state.sex = sex
      state.userId = loginInfo['userId']

    },
    [SETMOBILE] (state, value) {
      state.mobilePhone = value
    },
    [SETREFRESHTOKEN] (state, value) {
      state.refreshToken = value
    },
    [SETTOKEN] (state, value) {
      state.token = value
    },
    [SETCITY] (state, value) {
      state.currentCity = value
    }, //
    [SETLOGIN] (state, value) {
      state.isSignSuccess = value
    }, //SETWXLOGIN
    [SETWXLOGIN] (state, value) {
      state.isWxLogin = value
    },
    [SETUSERID] (state, value) {
      state.userId = value
    }
  },
  getters: {
    // getIsSignSuccess (state) {
    //   if (state.isSignSuccess === true) {
    //     return true
    //   }
    //   // localStorage.getItem("userIsLogin");
    //   var isLogin = Boolean(localStorage.getItem("userIsLogin"))
    //   console.log('get sign')
    //   console.log(localStorage.getItem("userIsLogin"))
    //   if (isLogin === true) {
    //     var loginTime = new Date(localStorage.getItem("userloginTime"))
    //
    //     loginTime.setTime(loginTime.getTime()+6*60*60*1000);
    //     var nowTime = new Date()
    //     if (nowTime > loginTime) {
    //       localStorage.setItem('userIsLogin', false)
    //       return false
    //     }
    //     else {
    //       return true
    //     }
    //   }
    //   else {
    //     return false
    //   }
    //
    // }
  }
}



// WEBPACK FOOTER //
// ./src/js/store/common/user.js